import * as types from './types';
import actions from './actions';
import {
  extend,
  each,
  set
} from 'lodash';

const state = {
  adminToolBookStatementTeacherList: {
    state: '',
    list: [],
    total: 0,
  },
};

const getters = {
  getAdminToolBookStatementTeacherList: (state) => state.adminToolBookStatementTeacherList,
};

const mutations = {
  [types.ACTION_ADMIN_TOOL_BOOK_STATEMENT_TEACHER_LIST]({adminToolBookStatementTeacherList}, result){
    extend(adminToolBookStatementTeacherList, result)
  },
};


export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Admin/modules/teacherInformationSheet/index.js